<template>
  <!-- Dashboard Page Wrapper -->
  <div
    class="columns flex-1"
    style="min-height: 63vh"
  >
    <!-- Side Menu -->
    <SideMenu />
    <!-- Dashboard Content -->
    <div class="dashboard login-page column">
      <!-- Professional Profile -->
      <professionalProfileSection v-if="activeDashboardSection == 'professionalProfileSection'" />
      <!-- User Profile -->
      <UserProfileSection v-if="activeDashboardSection == 'userProfileSection'" />
      <!-- Subscription -->
      <SubscriptionSection v-if="activeDashboardSection == 'subscriptionSection'" />
      <!-- Post -->
      <BlogSection v-if="activeDashboardSection == 'postSection'" />
      <!-- Users -->
      <UsersSection v-if="activeDashboardSection == 'users' && isAdmin" />
      <!-- Moderation -->
      <ModerationSection v-if="activeDashboardSection == 'moderation' && isAdmin" />
      <!-- Favorites -->
      <FavoritesSection v-if="activeDashboardSection == 'favorites'" />

      <!-- Plans -->
      <PlansSection v-if="activeDashboardSection == 'plans' && isAdmin"/>
    </div>
  </div>
</template>
<script>

import SideMenu from '../components/Dashboard/SideMenu'
import ProfessionalProfileSection from '../components/Dashboard/ProfessionalProfileSection'
import UserProfileSection from '../components/Dashboard/UserProfileSection'
import BlogSection from '../components/Dashboard/BlogSection'
import ModerationSection from '../components/Dashboard/ModerationSection'
import PlansSection from '../components/Dashboard/PlansSection'
import UsersSection from '../components/Dashboard/UsersSection'
import SubscriptionSection from '../components/Dashboard/SubscriptionSection'
import FavoritesSection from '../components/Dashboard/FavoritesSection'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    BlogSection,
    SideMenu,
    ProfessionalProfileSection,
    UserProfileSection,
    ModerationSection,
    PlansSection,
    UsersSection,
    SubscriptionSection,
    FavoritesSection
  },
  computed: {
    ...mapState(['activeDashboardSection', 'isAdmin', 'userProfile'])
  },
  methods: {
    ...mapActions(['setActiveDashboardSection'])
  },
  created () {
    this.$store.dispatch('checkAdminStatus')
  },
  watch: {
    '$route' () {
      (!this.setActiveDashboardSection &&
        this.userProfile.uerType === 'professional')
        ? this.setActiveDashboardSection('professionalProfileSection')
        : this.setActiveDashboardSection('userProfileSection')
    }
  }
}

/* @todo
- Permitir que usuário possa apagar Post
- Ao alterar a imagem de perfil mostrar o arquivo carregado
- Ao alterar a imagem de perfil, atualizar as referencias a imagem de perfil nos posts do usuário
*/
</script>

<style scoped="">
img.preview {
  width: 200px;
}
</style>
